
import { Injectable } from '@angular/core';
import { ComponentModelGQL } from '../../graphql';
import { Observable } from 'rxjs';
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ComponentModel } from 'app/models/monitor/component-model.model';

@Injectable({
  providedIn: 'root',
})
export class ComponentModelService {

  constructor(
    private componentModelGQL: ComponentModelGQL
  ) { }

  public getTurbineModelData(serialNumberObservable: Observable<number>): Observable<ComponentModel> {
    return serialNumberObservable.pipe(
      distinctUntilChanged(),
      switchMap((serialNav: number) =>
        this.componentModelGQL.subscribe({
          variables: {
            serialNav
          }
        }).pipe(
          map(result => ComponentModel.mapFromComponentModel(result.data.turbines[0]))
        )
      )
    );
  }
}
